interface ChartTooltipPayload {
  color?: string;
  name?: string | number;
  value?: string | number;
}

interface ChartTooltipContentProps {
  active?: boolean;
  label?: string;
  payload?: ChartTooltipPayload[];
  title?: string;
  valueSuffix?: string;
}

export function ChartTooltipContent({
  active,
  label,
  payload,
  title,
  valueSuffix = ""
}: ChartTooltipContentProps) {
  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className="chart-tooltip stack-xs">
      <div className="chart-tooltip-title">{title ?? label}</div>
      {label && title ? <div className="chart-tooltip-label">{label}</div> : null}
      <div className="chart-tooltip-list">
        {payload
          .filter((entry) => entry.value !== undefined && entry.value !== null)
          .map((entry) => (
            <div key={`${entry.name}-${entry.value}`} className="chart-tooltip-row">
              <div className="chart-tooltip-name">
                <span className="chart-tooltip-swatch" style={{ backgroundColor: entry.color ?? "var(--accent-primary)" }} />
                <span>{entry.name}</span>
              </div>
              <strong className="chart-tooltip-value">{`${entry.value}${valueSuffix}`}</strong>
            </div>
          ))}
      </div>
    </div>
  );
}
